/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { put, takeEvery } from 'redux-saga/effects';
import { SET_VALUE } from 'src/types/config-action.type';
import { setConfigValueSuccess, setConfigValueError } from '../actions/config.action';

function* onSetConfig(action:any):any {
  try {
    let data = action.payload;
    if (data && data?.field) {
      yield put(setConfigValueSuccess(data));
    } else {
      throw new Error ("Empty data set");
    }
  } catch(err) {
    yield put(setConfigValueError());
  }
}

export function* watchOnSetConfig() {
  yield takeEvery(SET_VALUE, onSetConfig);
}